// removed by extract-text-webpack-plugin
module.exports = {"headerRow":"_3r9ZZOau5tneyx87PafvBu","headerTitle":"_1ozN79VgS4HIzSKcSltOTt","qpane":"meej06Sb0ryynkQAIRiik","qpaneSize":"_3vm_qkUwxLjNfV5pF377Aa","question":"_1-JTb4bTFyXyl8qc3hHejB","insidepane":"ry_Ug4hoP1Z1HgYwIemVO","answerButton":"_3Yu3-EUu_Lq_Tder6V0mp1","stepOn":"_235vU_zhdTN-YU9Ocp8bEg","stepOff":"_2G7v5JlqjDixcDlLLiVFbU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ClientMode/RetirementRegret.css
// module id = 704
// module chunks = 0